import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Info, Wifi, WifiOff } from "lucide-react";

interface RPCStatusProps {
  endpoint: string;
  isConnected: boolean;
  selectedRpc: string;
  onChangeRPC: () => void;
}

export function RPCStatus({
  endpoint,
  isConnected,
  selectedRpc,
  onChangeRPC,
}: RPCStatusProps) {
  return (
    <div className="bg-[#ffffff]/5 rounded-lg p-3 space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-xs">
          <div className="flex items-center gap-1.5">
            {isConnected ? (
              <>
                <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
                <span className="text-green-500 font-medium">Connected</span>
              </>
            ) : (
              <>
                <div className="w-1.5 h-1.5 rounded-full bg-red-500" />
                <span className="text-red-500 font-medium">Disconnected</span>
              </>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          {selectedRpc === "custom-devnet" && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onChangeRPC}
              className="h-6 px-2 text-xs bg-[#ffffff]/5 hover:bg-[#ffffff]/10 text-[#9945FF]"
            >
              Change
            </Button>
          )}
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Info className="h-3.5 w-3.5 text-[#ffffff]/30 hover:text-[#ffffff]/50 cursor-help transition-colors" />
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-xs">Current RPC endpoint status</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </div>
      <div className="flex items-center gap-2 text-xs bg-[#000000]/20 p-2 rounded-md">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="text-[#ffffff]/70 hover:text-[#ffffff] cursor-help transition-colors truncate max-w-[300px] font-mono">
                {endpoint}
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-xs break-all font-mono">{endpoint}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
}
